<template>
  <div class="dbNavList">
    <div class="flex a-c" style="margin-bottom: 20px;">
      <div class="input-container flex a-c" style="flex: 1">
        <el-input v-model="paramsFilter.isbn" placeholder="请输入 ISBN" clearable @clear="getTable" @keyup.enter="getTable"/>
        <div class="button-container" @click="getTable"><i class="iconfont unify-sousuo"></i></div>
      </div>
      <div class="action-button" @click="showImportDialog">导入</div>
      <div class="my-button" @click="showDialog" title="新增禁书">
        <i class="iconfont jia unify-tianjia"></i>
      </div>
    </div>

    <div>
      <el-table :data="state.tableData" stripe style="width: 100%" class="my-table"
                max-height="calc(100vh - 300px)" v-loading="tableLoading">
        <el-table-column type="index" label="序号" width="80" align="center"/>
        <el-table-column prop="isbn" label="ISBN" min-width="200" align="center"/>
        <el-table-column prop="createdTimeStr" label="创建时间" min-width="180" align="center">
          <template #default="scope">
            {{ scope.row.createdTimeStr || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template #default="scope">
            <span class="delete-text-button" @click="deleteHandler(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex a-c" style="justify-content: flex-end;margin-top: 20px">
        <span style="margin-right: 12px;color: #6573A2;font-size: 16px">总数：{{ total }}</span>
        <div class="page-button-pre" @click="handlePageClick(false)">上一页</div>
        <el-pagination
            background
            layout="pager,sizes"
            v-model:page-size="paramsFilter.limit"
            :page-sizes="[5,10,20]"
            :current-page="paramsFilter.currentPage"
            @current-change="handlerPageNumChange"
            @size-change="handlerPageSizeChange"
            :total="total"/>
        <div class="page-button-next" @click="handlePageClick(true)">下一页</div>
      </div>
    </div>
    <addDialog @success="success" ref="addDialogComp"/>
    <importDialog @success="importSuccess" ref="importDialogComp"/>
  </div>
</template>

<script>
import {
  findSchoolResourceIsbnFilterPage,
  deleteSchoolResourceIsbnFilterById,
} from "@/js/network/main"
import {reactive, ref} from "vue";
import {MessageBox} from "@/js/utils/commonJs";
import addDialog from "./addDialog";
import importDialog from "./importDialog";
import {ElMessageBox} from "element-plus";

export default {
  components: {
    addDialog,
    importDialog,
  },
  setup() {
    const addDialogComp = ref(null);
    const importDialogComp = ref(null);
    const tableLoading = ref(false);
    let paramsFilter = reactive({
      isbn: "",
      limit: 10,
      currentPage: 1,
    });
    let state = reactive({
      tableData: [],
    })
    let total = ref(0);

    // 查询列表
    const getTable = function () {
      tableLoading.value = true;
      findSchoolResourceIsbnFilterPage(paramsFilter).then(res => {
        tableLoading.value = false;
        if (!res || !res.success) {
          MessageBox.error(res?.msg || '查询失败');
          return;
        }
        state.tableData = res.data || [];
        total.value = parseInt(res.count || 0);
      }).catch(error => {
        tableLoading.value = false;
        console.log(error, "catchError");
      });
    }

    const success = function () {
      getTable();
    }

    // 导入成功后刷新列表
    const importSuccess = function () {
      paramsFilter.currentPage = 1;
      getTable();
    }

    const handlerPageNumChange = function (num) {
      paramsFilter.currentPage = num;
      getTable();
    }

    const handlerPageSizeChange = function (num) {
      paramsFilter.limit = num;
      paramsFilter.currentPage = 1;
      getTable();
    }

    // 删除禁书
    const deleteHandler = function (row) {
      ElMessageBox.confirm('确定要删除该禁书记录吗?').then((action) => {
        if (action) {
          deleteSchoolResourceIsbnFilterById({id: row.id}).then(res => {
            if (!res || !res.success) {
              MessageBox.error(res?.msg || '删除失败');
              return;
            }
            getTable();
            MessageBox.success(res.msg || '删除成功!');
          }).catch(error => {
            console.log(error, "catchError");
          });
        }
      }).catch(() => {
      })
    }

    const showDialog = function () {
      addDialogComp.value.init();
    }

    // 打开导入弹窗
    const showImportDialog = function () {
      importDialogComp.value.init();
    }

    const handlePageClick = function (flag) {
      flag ? paramsFilter.currentPage++ : paramsFilter.currentPage--;
      if (paramsFilter.currentPage < 1) {
        paramsFilter.currentPage = 1;
        return;
      }
      let max = Math.ceil(total.value / paramsFilter.limit) || 1;
      if (paramsFilter.currentPage > max) {
        paramsFilter.currentPage = max;
        return;
      }
      getTable();
    }

    getTable();

    return {
      tableLoading,
      paramsFilter,
      state,
      total,
      getTable,
      success,
      importSuccess,
      handlePageClick,
      handlerPageNumChange,
      handlerPageSizeChange,
      deleteHandler,
      showDialog,
      showImportDialog,
      addDialogComp,
      importDialogComp,
    }
  }
}
</script>

<style scoped lang="scss">
.dbNavList {
  padding: 20px 0;
  background-color: #ffffff;
  border-radius: 20px 0 0 0;
}

.input-container {
  height: 38px;
  border: 1px solid #ccc;
  border-radius: 4px;

  .iconfont {
    font-size: 20px;
    font-weight: 600;
  }

  :deep(.el-input__wrapper) {
    box-shadow: none !important;
    background: transparent !important;

    &.is-focused {
      box-shadow: none !important;
    }

    &.is-hovering {
      box-shadow: none !important;
    }
  }
}

.my-button {
  width: 60px;
  height: 40px;
  background-color: #2054D6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 18px;
  cursor: pointer;
}

.jia {
  font-size: 24px;
  color: #ffffff;
  cursor: pointer;
}

.action-button {
  min-width: 72px;
  height: 40px;
  margin-left: 18px;
  padding: 0 16px;
  background-color: #2054D6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

.input-container:focus-within {
  border: 1px solid #409eff;
}

.button-container {
  height: 40px;
  width: 64px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
  background: #2054D6;
  border-radius: 0px 2px 2px 0;
}

.delete-text-button {
  font-size: 14px;
  color: red;
  user-select: none;
  cursor: pointer;
  text-decoration: underline;
}

.my-table {
  border: 1px solid #DCE1F0;
  border-radius: 10px 10px 10px 10px;
}

.page-button-next {
  width: 72px;
  height: 40px;
  background: #EEF2FE;
  border-radius: 10px 10px 10px 10px;
  font-size: 16px;
  color: #6573A2;
  line-height: 40px;
  text-align: center;
  opacity: 1;
  border: 1px solid #DCE1F0;
  user-select: none;
  cursor: pointer;
  margin-left: 15px;
}

.page-button-pre {
  width: 72px;
  height: 40px;
  background: #EEF2FE;
  border-radius: 10px 10px 10px 10px;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  color: #6573A2;
  opacity: 1;
  border: 1px solid #DCE1F0;
  user-select: none;
  cursor: pointer;
  margin-right: 15px;
}

:deep(.el-table__header) {
  border-radius: 10px 10px 0px 0px;
  opacity: 1;
  height: 64px;

  .el-table__cell {
    background: #EEF2FE !important;
    color: #6573A2;
  }
}

:deep(.el-table__row) {
  height: 64px;

  .el-table__cell {
    color: #6573A2;
  }
}

:deep(.el-table__row--striped) {
  .el-table__cell {
    background: #F8F9FD !important;
  }
}

:deep(.el-pager) {
  .number {
    font-size: 14px;
    color: #6573A2;
    background: none !important;
  }

  .more {
    background: none !important;
  }

  .is-active {
    width: 40px;
    height: 40px;
    background: #2054D6 !important;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    border: 1px solid #DCE1F0;
  }
}
</style>
